<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-row :gutter="gutter">
        <a-col :md="6" :sm="24">
          <a-form-item label="在职状态">
            <a-select
              :allowClear="true"
              v-model="searchModel.status"
              placeholder="请选择在职状态"
            >
              <a-select-option v-for="(item, index) in statusList" :value="item.value" :key="index">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="职位">
            <a-select
              :allowClear="true"
              v-model="searchModel.departmentJob"
              placeholder="请选择职位"
            >
              <a-select-option v-for="(item, index) in jobList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="在岗类型">
            <a-select
              :allowClear="true"
              v-model="searchModel.jobStatus"
              placeholder="请选择在岗类型"
            >
              <a-select-option v-for="(item, index) in jobStatusList" :value="item.value" :key="index">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="姓名">
            <a-input placeholder="请输入姓名" autocomplete="off" v-model="searchModel.userName" />
          </a-form-item>
        </a-col>
        <a-col :offset="18" :md="6" :sm="24" style="text-align:right">
          <a-button type="primary" @click="search">查询</a-button>
          <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QualitySearchForm',
  data () {
    return {
      gutter: 20,
      searchModel: {},
      statusList: [
        { value: 1, label: '正常' },
        { value: 9, label: '离职' }
      ],
      jobStatusList: [
        { value: 1, label: '正式' },
        { value: 2, label: '试用' },
        { value: 3, label: '实习' }
      ],
      advanced: false
    }
  },
  computed: {
    ...mapGetters(['jobList'])
  },
  mounted () {
    this.searchModel = {
      status: 1
    }
  },
  methods: {
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.userName) {
        model.userName = model.userName.trim()
      }
      for (var key in model) {
        if (!model[key] && model[key] !== 0) {
          delete model[key]
        }
      }
      this.$emit('setSearchCondition', model)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {
        status: 1
      }

      this.$emit('clearSearch', this.searchModel)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style scoped>
</style>
